import React from "react";
import { ReactComponent as SwiftLogo } from "./zeidler-swift-logo.svg";
const Logo: React.FC = () => {
  return <SwiftLogo />;
};
export default Logo;
